import { Button, aimg, utility } from '@phi/components';
import { VNode, defineComponent, h } from 'vue';
import website from './website.svg';
import message from './message.svg';
import call from './call.svg';
import styles from './index.module.scss';
import { Flex } from '@phi/components/layout';

export default defineComponent({
    emits: {
        'update:stage': (x: number) => true,
    },

    setup() {
        return () => h(Flex, {
            class: [ utility.do_interact_with_children, styles.container ],
            justify: 'space-evenly',
        }, () => [
            Section(
                'For more material and examples',
                Figure('phi3d.com', website, 'https://phi3d.com'),
            ),
            Section(
                'For further support, contact us',
                Figure('Message us', message, 'https://phi3d.com/contact'),
                Figure('Book free call', call, 'https://calendly.com/phi-support/getting-started'),
            )
        ]);
    },
});

function Figure(label: string, img: string, link: string) {
    return h('figure', { class: [ styles.img, utility.margin_gap_3 ] }, [
        aimg(link, true, img, label),
        h('figcaption', h(Button, {
            class: styles.button,
            href: link,
            variant: 'primary',
            in_new_tab: true,
        }, () => label))
    ]);
}

function Section(header: string, ...children: Array<VNode>) {
    return h('section', { class: utility.margin_gap_3 }, [
        h('header', { class: utility.center }, header),
        h(Flex, {
            direction: 'row',
            align: 'center',
            justify: 'space-evenly',
        }, () => children),
    ]);
}
